import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function BOMSelectModal({ title, onClose, handleBOMClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    partner_name: true,
    partner_type: false,
    partner_type_name: true,
    partner_number: true,
    partner_corp_number: true,
    partner_ceo: true,
    partner_ceo_phone: false,
    partner_ceo_email: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      bom_name: true,
      bom_item_count: false,
      item_id: false,
      item_name: true,
      item_spec: false,
      item_width: false,
      item_depth: false,
      item_height: false,
      item_full_spec: true,
      item_type: false,
      item_type_name: false,
      item_division: false,
      item_division_name: false,
      input_item_ids: false,
      input_item_names: false,
      input_item_specs: false,
      input_item_widths: false,
      input_item_heights: false,
      input_item_depths: false,
      input_item_count: false,
      input_item_stocks: false,
      input_item_use_stocks: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'bom_id', width: 0, headerAlign: 'center' },
        { field: 'bom_name', headerName: 'BOM', width: 180, headerAlign: 'center' },
        { field: 'bom_item_count', headerName: 'bom_item_count', width: 0, headerAlign: 'center' },
        { field: 'item_id', headerName: 'item_id', width: 0, headerAlign: 'center' },
        { field: 'item_name', headerName: '품목', width: 100, headerAlign: 'center' },
        { field: 'item_spec', headerName: 'item_spec', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_width', headerName: 'item_width', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_depth', headerName: 'item_depth', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_height', headerName: 'item_height', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_full_spec', headerName: '규격', width: 250, headerAlign: 'center' },
        { field: 'item_type', headerName: 'item_type', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_type_name', headerName: 'item_type_name', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_division', headerName: 'item_division', width: 0, headerAlign: 'center', align:'center' },
        { field: 'item_division_name', headerName: 'item_division_name', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_ids', headerName: 'input_item_ids', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_names', headerName: 'input_item_names', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_specs', headerName: 'input_item_specs', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_count', headerName: 'input_item_count', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_widths', headerName: 'input_item_widths', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_heights', headerName: 'input_item_heights', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_depths', headerName: 'input_item_depths', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_stocks', headerName: 'input_item_stocks', width: 0, headerAlign: 'center', align:'center' },
        { field: 'input_item_use_stocks', headerName: 'input_item_use_stocks', width: 0, headerAlign: 'center', align:'center' },
    ]);
  }

  const handleView = () => {
    axios.get('/api/SelectCommon/BOMList',
        {
        params : {
          keyword: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        var array = response.data.map((item, index) => ({
            id: item.bom_id,
            bom_name: item.bom_name,
            bom_item_count: item.bom_item_count,
            item_id: item.item_id,
            item_name: item.item_name,
            item_spec: item.item_spec,
            item_width: item.item_width,
            item_depth: item.item_depth,
            item_height: item.item_height,
            item_full_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
            item_type: item.item_type,
            item_type_name: item.item_type_name,
            item_division: item.item_division,
            item_division_name: item.item_division_name,
            input_item_ids: item.input_item_ids,
            input_item_names: item.input_item_names,
            input_item_specs: item.input_item_specs,
            input_item_widths: item.input_item_widths,
            input_item_heights: item.input_item_heights,
            input_item_depths: item.input_item_depths,
            input_item_count: item.input_item_count,
            input_item_stocks: item.input_item_stocks,
            input_item_use_stocks: item.input_item_use_stocks
        }));
        setRows(array);
        
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handlePartnerClick 이벤트 만들어 놓아야함.
    handleBOMClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleBOMClick({
      id: '',
      bom_name: '',
      bom_item_count: '',
      item_id: '',
      item_name: '',
      item_spec: '',
      item_width: '',
      item_depth: '',
      item_height: '',
      item_full_spec: '',
      item_type: '',
      item_type_name: '',
      item_division: '',
      item_division_name: '',
      input_item_ids: '',
      input_item_names: '',
      input_item_specs: '',
      input_item_widths: '',
      input_item_heights: '',
      input_item_depths: '',
      input_item_count: '',
      input_item_stocks: '',
      input_item_use_stocks: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default BOMSelectModal;